import { FC } from 'react';
import { RaceDatas } from '../types';
import { Gauge } from './gauge';
import './raceprogress.scss';

/* -------------------------------------------------------------------------------- *\
|                               ProgressProps
\* -------------------------------------------------------------------------------- */
interface ProgressProps
{
	racedatas: RaceDatas | null,
	timefromstart: string,
    children?: Node,
}
/* -------------------------------------------------------------------------------- *\
|                               Progress
\* -------------------------------------------------------------------------------- */
export const Progress : FC<ProgressProps> = ({racedatas, timefromstart}) =>    
{
    return (
        <div className="progress">
            <div className='progress__value'>
                {/* <div className="progress__value__text">Race { racedatas  ? racedatas.showeddistance + "m" : ""}</div> */}
                    <Gauge percent={racedatas && racedatas.distance ? Math.floor(racedatas.position / racedatas.distance * 100) : 0} timefromstart={timefromstart} />
            </div>
            {/* <div className='progress__separator'></div>
            <div className='progress__infos'>{racedatas && racedatas.started ? "started" : "not started"}</div>
            <div className='progress__infos'>{racedatas && racedatas.finished ? "finished" : "not finished"}</div> */}
        </div>
    );
}
